import { Vector } from './Vector'
import { Plane } from './Plane'
import { CarGameObject } from './GameObject'

export class Collision {
    static PlaneIntersection(obj : CarGameObject, plane: Plane, log? : boolean) {
        //      \
        //       \
        //   *    \
        //         \
        var perpendicularDistanceToPlane = Plane.halfPlaneTest(plane, obj.FromPosition);  // signed distance 
        // plane.normal . ball.movement
        // we can consider the following dot product similar to the halfplane test above
        // plane.normal is normalised ||1|| but we arent considering plane.d (so the plane goes through origin)
        // ball.movement is a vector (point) from the origin that represents the balls movement
        // the sign tells us if we are moving towards the plane (<0)
        // the value is the perpendicular distance of the "movement" (point) to the plane!
        var perpendicularMovementToPlane = Vector.dotProduct(Vector.normalise(plane.normal), obj.Movement);  // sign tells us if we are moving towards the plane
        //            float movmentMagnitude = Vector.magnitude(ball.Movement);  // sign tells us if we are moving towards the plane

        if (log)
            console.log(perpendicularDistanceToPlane + '  ' + perpendicularMovementToPlane);

        //    Console.WriteLine(string.Format("{0} Distance {1} Dot Product {2}", plane.id, perpendicularDistanceToPlane, perpendicularMovementToPlane));

        const r = obj.radius(plane);
        const signedDistanceToContactPlane = perpendicularDistanceToPlane - r;

        // No movement along plane normal means we cannot hit this plane this step.
        if (perpendicularMovementToPlane === 0) {
            return false;
        }

        // Solve signedDistanceToContactPlane + t * perpendicularMovementToPlane = 0.
        // what is the distance away as a fraction of the full movement
        // i.e. if the ditance away is > the movement, then t > 1 so there is no collision
        // when the distance away is < the movement, then it is afraction of the movement, t < 1 and there is a collision
        var t = -signedDistanceToContactPlane / perpendicularMovementToPlane;

        // if collision occurs within the movement of the object
        if (t > 0 && t < 1) {
            // trim the moevement to point of collision!
            obj.Movement = Vector.scale(obj.Movement, t);
            obj.ToPosition = Vector.add(obj.FromPosition, obj.Movement);
            //     ball.Stop();
            return true;
        }

        return false;
    }

    /**
     * Plane constraint test for barriers: prevents movement further into the "bad" side of a plane.
     * Unlike PlaneIntersection which detects future crossings, this handles cases where the object
     * has already penetrated past the plane (e.g., when AABB overlap is detected too late).
     * 
     * The "bad" side is opposite to the plane normal (inside the barrier).
     * If the object is on the bad side AND moving further into it, constrain the movement
     * to slide along the plane instead.
     * 
     * @param obj - The car object with position and movement
     * @param plane - The barrier plane (normal points outward from barrier)
     * @returns true if movement was constrained, false otherwise
     */
    static PlaneConstraint(obj: CarGameObject, plane: Plane): boolean {
        // Check which side of the plane we're on
        const perpendicularDistanceToPlane = Plane.halfPlaneTest(plane, obj.FromPosition);
        
        // If center position has crossed to bad side, we're too far through - ignore this plane
        if (perpendicularDistanceToPlane < 0) {
            return false;
        }
        
        const r = obj.radius(plane);
        const signedDistanceToContactPlane = perpendicularDistanceToPlane - r;
        
        // If we're on the "good" side (positive distance), no constraint needed
        if (signedDistanceToContactPlane >= 0) {
            return false;
        }
        
        // We're on the "bad" side (penetrated). Check if movement goes further in.
        const perpendicularMovementToPlane = Vector.dotProduct(plane.normal, obj.Movement);
        
        // If moving away from bad side (positive), allow it
        if (perpendicularMovementToPlane >= 0) {
            return false;
        }
        
        // Movement is taking us further into the bad side.
        // Project movement onto the plane to slide along it instead.
        // Remove the component perpendicular to the plane.
        const projectedMovement = Vector.subtract(
            obj.Movement,
            Vector.scale(plane.normal, perpendicularMovementToPlane)
        );
        
        obj.Movement = projectedMovement;
        obj.ToPosition = Vector.add(obj.FromPosition, obj.Movement);
        
        return true;
    }
}